import {
  DesignTemplates,
  defaultDataControlSetting,
  templatesWithPricingOffByDefault,
} from '@zoomcatalog/design-templates';

export function getCustomDataControlSetting(_templateName: DesignTemplates) {
  const templates: Readonly<string[]> = templatesWithPricingOffByDefault;
  const templateName: string = _templateName;
  if (templates.includes(templateName)) {
    return {
      pricing: {
        ...defaultDataControlSetting,
        isVisible: false,
      },
    };
  }
  return {};
}
